var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',[_vm._v(_vm._s(_vm.$options.statusMapping[`${_vm.slotParams.item.status}_`]))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }